import React from "react";
import ReactDOM from "react-dom/client";
import { Theme } from "config/styles/Theme";
import { GlobalStyles } from "@mui/material";
import { globalStyles } from "config/styles/GlobalStyle";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./store";
import PageRoot from "./pages/PageRoot";
import { webordersApi } from "store/api";
import { setConfig } from "store/slices/settings";
import "styles.css";
import "react-toastify/dist/ReactToastify.css";

const appGlobalStyles = <GlobalStyles styles={globalStyles} />;

const initApp = async () => {
  try {
    const configResponse = await store
      .dispatch(webordersApi.endpoints.getConfig.initiate())
      .unwrap();
    store.dispatch(setConfig(configResponse));
  } catch (error) {
    console.error("Failed to fetch config", error);
  }

  const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
  );

  root.render(
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Theme>
          {appGlobalStyles}
          <PageRoot />
        </Theme>
      </PersistGate>
    </Provider>,
  );
};

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then(() => {
      console.log("Service Worker registered:");
    })
    .catch((error) => {
      console.error("Service Worker registration error:", error);
    });
}

initApp();
